import BarChart from './charts/BarChart';
import PieChart from './charts/PieChart';
import styles from "./analytics.module.scss";

const CHART_COMPONENTS = {
    // Clé : Nom du composant React
    'barChart': BarChart,
    'pieChart': PieChart,

    // Ajoutez les futurs types ici :
    // 'heatmap': HeatmapChart,
    // 'radar': RadarChart,
    // 'twoLevelPie': TwoLevelPieChart,
    //   ...
};

function ChartContainer({ label, data, config, type, isLoading }) {
    const ChartComponent = CHART_COMPONENTS[type];

    if (!ChartComponent) {
        console.warn(`Le type de graphique "${type}" n'est pas configuré.`);
        return (
            <div className={styles.chartContainer}>
                <div className={styles.top}>
                    <p className={styles.label}>{label}</p>
                </div>
                <div className={styles.loadingContainer}>
                    <div className={styles.error}>
                        Configuration manquante pour ce graphique.
                    </div>
                </div>
            </div>
        );
    }
    if (isLoading) {
        return (
            <div className={styles.chartContainer}>
                <div className={styles.top}>
                    <p className={styles.label}>{label}</p>
                </div>
                <div className={styles.loadingContainer}>
                    <div className="w-8 h-8 border-4 border-slate-300 border-t-blue-500 rounded-full animate-spin"></div>
                </div>
            </div>
        );
    }
    return (
        <div className={styles.chartContainer}>
            <div className={styles.top}>
                <p className={styles.label}>{label}</p>
            </div>
            <ChartComponent data={data} config={config} />
        </div>
    );
}

export default ChartContainer;

